
    const _each = require("lodash/each");
    const _times = require("lodash/times");
    const _escape = require("lodash/escape");
    const _throttle = require("lodash/throttle");

    const _ = {
        each: _each,
        times: _times,
        escape: _escape,
        throttle: _throttle,
    };

    module.exports = function(context) {
var __t, __p = '';
__p += '<div class="delete-payment-confirm"><h3>Delete this payment method?</h3><p>You will need to create a new payment method the next time you checkout.</p><button class="button button--red delete-payment-confirm__button">Delete</button><button class="button secondary-button overlay-close">Cancel</button></div>';
return __p
};
    